var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.42516 17.2248C7.26683 17.2248 7.1085 17.1664 6.9835 17.0414C6.74183 16.7998 6.74183 16.3998 6.9835 16.1581L12.4168 10.7248C12.8168 10.3248 12.8168 9.67477 12.4168 9.27477L6.9835 3.84144C6.74183 3.59977 6.74183 3.19977 6.9835 2.95811C7.22516 2.71644 7.62516 2.71644 7.86683 2.95811L13.3002 8.39144C13.7252 8.81644 13.9668 9.39144 13.9668 9.99977C13.9668 10.6081 13.7335 11.1831 13.3002 11.6081L7.86683 17.0414C7.74183 17.1581 7.5835 17.2248 7.42516 17.2248Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightMobile);
export default __webpack_public_path__ + "static/media/arrow-right-mobile.4e1853ad063aceb100d3d15b56be083b.svg";
export { ForwardRef as ReactComponent };